/**
 * Case-study grid below full-page snapshots. `stack` must match a LEGACY_FILTER id (except '*').
 */
const legacyPortfolioProjects = [
  {
    image: 'img/trueopinion-p-1.png',
    href: 'https://surveys.authenticopinion.com/clientpanel',
    title: 'TRUEOPINION',
    stack: 'laravel',
    colSpan: 6,
    alt: 'TRUEOPINION surveys client panel — project preview',
  },
  {
    image: 'img/tosall-p-1.png',
    href: 'https://web.kailashchandra.com/tosall_client/',
    title: 'AI chatbot',
    stack: 'codeigniter',
    colSpan: 6,
    alt: 'TOSALL AI chatbot admin — project preview',
  },
  {
    image: 'img/indiafreelancer.jpg',
    href: 'https://indiafreelancers.in',
    title: 'India Freelancer',
    stack: 'react',
    colSpan: 4,
    alt: 'India Freelancers marketplace — project preview',
  },
  {
    image: 'img/pscs-p-1.png',
    href: 'https://web.kailashchandra.com/pscs/front/',
    title: 'Palm Springs Car Storage',
    stack: 'codeigniter',
    colSpan: 4,
    alt: 'Palm Springs Car Storage — project preview',
  },
  {
    image: 'img/cashew-p-1.png',
    href: 'https://web.kailashchandra.com/cashewprotect/',
    title: 'Cashew Protect',
    stack: 'laravel',
    colSpan: 4,
    alt: 'Cashew Protect — project preview',
  },
  {
    image: 'img/fashionzapp.png',
    href: 'https://fashionzapp.com/',
    title: 'Fashionzapp',
    stack: 'magento',
    colSpan: 4,
    alt: 'Fashionzapp e-commerce — project preview',
  },
  {
    image: 'img/cuffsnlashes.jpg',
    href: 'https://www.cuffsnlashes.com/',
    title: 'Cuffs N Lashes',
    stack: 'magento',
    colSpan: 4,
    alt: 'Cuffs N Lashes cosmetics — project preview',
  },
  {
    image: 'img/faber.jpg',
    href: 'https://faberkart.com/',
    title: 'Faberkart',
    stack: 'magento',
    colSpan: 4,
    alt: 'Faberkart — project preview',
  },
  {
    image: 'img/dhenusudha.jpg',
    href: 'https://dhenusudha.com/',
    title: 'Dhenu Sudha',
    stack: 'magento',
    colSpan: 4,
    alt: 'Dhenu Sudha — project preview',
  },
  {
    image: 'img/mensfitclub.jpg',
    href: 'https://www.mensfitclub.com/',
    title: "Men's Fit Club",
    stack: 'wordpress',
    colSpan: 4,
    alt: "Men's Fit Club — project preview",
  },
  {
    image: 'img/tipster-p-1.png',
    href: 'https://tipsterchallenge.com/',
    title: 'Tipster Challenge',
    stack: null,
    colSpan: 4,
    alt: 'Tipster Challenge horse racing — project preview',
  },
  {
    image: 'img/ellasbubble.jpg',
    href: 'https://ellasbubbles.com/',
    title: "Ella's Bubbles",
    stack: 'wordpress',
    colSpan: 4,
    alt: "Ella's Bubbles — project preview",
  },
  {
    image: 'img/app-3.png',
    href: 'https://play.google.com/store/apps/details?id=com.wecharge',
    title: 'WeCharge — customer app',
    stack: 'reactnative',
    colSpan: 4,
    alt: 'WeCharge customer app on Google Play',
  },
  {
    image: 'img/app-3.png',
    href: 'https://play.google.com/store/apps/details?id=com.wecharge',
    title: 'WeCharge — delivery app',
    stack: 'reactnative',
    colSpan: 4,
    alt: 'WeCharge delivery driver app on Google Play',
  },
  {
    image: 'img/balaji.jpg',
    href: 'https://www.balajimariline.com/',
    title: 'Balaji Mariline',
    stack: 'wordpress',
    colSpan: 4,
    alt: 'Balaji Mariline logistics — project preview',
  },
];

export const LEGACY_FILTERS = [
  { id: '*', label: 'All projects' },
  { id: 'magento', label: 'Magento' },
  { id: 'react', label: 'React' },
  { id: 'reactnative', label: 'React Native' },
  { id: 'laravel', label: 'Laravel' },
  { id: 'wordpress', label: 'WordPress' },
  { id: 'codeigniter', label: 'CodeIgniter' },
];

export function legacyProjectMatchesFilter(project, filterId) {
  if (filterId === '*') return true;
  return project.stack === filterId;
}

export default legacyPortfolioProjects;
